import React from "react";
import { Link as MuiLink, Stack } from "@mui/material";
import StandardLabel from "../../../helpers/StandardLabel";
import { Link } from "react-router-dom";

const UserSecondaryEmailsDisplay = ({
  secondaryEmails,
}) => {
  return (
    <Stack>
      <StandardLabel labelText="Secondary Emails"/>
      {secondaryEmails.map(email =>
        <Link
          key={email.userEmailEntityId}
          to={`../../emails/${email.userEmailEntityId}`}
        >
          <MuiLink
            component="span"
            variant="body1"
          >
            {email.email}
          </MuiLink>
        </Link>,
      )}
    </Stack>
  );
};

export default UserSecondaryEmailsDisplay;